import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'encodeHtml'
})
export class EncodeHtmlPipe implements PipeTransform {
  transform(value: any, reverse?: boolean): any {
    if (!value) {
      return value;
    }

    if (!reverse) {
      return value
        .replace(/</g, '&lt;')
        .replace(/"/g, '&quot;')
        .replace(/ /g, '&nbsp;')
        .replace(/'/g, '&#39;')
        .replace(/=/g, '&#x3D;')
        .replace(/`/g, '&#x60;')
        .replace(/>/g, '&gt;');
    } else {
      return value
        .replace(/&lt;/g, '<')
        .replace(/&quot;/g, '"')
        .replace(/&nbsp;/g, ' ')
        .replace(/&#39;/g, "'")
        .replace(/&#x3D;/g, '=')
        .replace(/&#x60;/g, '`')
        .replace(/&gt;/g, '>');
    }
  }
}
